import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPills, FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <motion.div 
              className="footer-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="footer-logo">
                <FaPills className="footer-logo-icon" />
                <div className="footer-logo-text">
                  <span className="footer-logo-main">SARVATMAN</span>
                  <span className="footer-logo-sub">LIFESCIENCE</span>
                </div>
              </div>
              <p className="footer-description">
                Empowering Lives with Precision Medicine. Specializing in Neuropathic Pain, 
                Pain Management, Migraine & Vertigo, Vitamins & Neuropathy, and PPIs with 
                innovation and care at the forefront.
              </p>
            </motion.div>

            {/* Quick Links */}
            <motion.div 
              className="footer-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Contact Info */}
            <motion.div 
              className="footer-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h3 className="footer-title">Contact Info</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <FaPhone className="contact-icon" />
                  <div>
                    <p>8883686347</p>
                    <p>9994501212</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaWhatsapp className="contact-icon whatsapp" />
                  <p>9659377555</p>
                </div>
                <div className="contact-item">
                  <FaEnvelope className="contact-icon" />
                  <p>sarvatmanlifescience@gmail.com</p>
                </div>
                <div className="contact-item">
                  <FaMapMarkerAlt className="contact-icon" />
                  <p>Coimbatore - 641010</p>
                </div>
              </div>
            </motion.div>

            {/* Specialties */}
            <motion.div 
              className="footer-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <h3 className="footer-title">Our Specialties</h3>
              <ul className="specialty-list">
                <li>Neuropathic Pain</li>
                <li>Pain Management</li>
                <li>Migraine & Vertigo</li>
                <li>Vitamins & Neuropathy</li>
                <li>PPIs (Acid-related disorders)</li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Sarvatman Lifescience. All rights reserved.
            </p>
            <p className="developer">
              Developed by{' '}
              <a href="#" className="developer-name" onClick={(e) => e.preventDefault()}>
                Entire Skill
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
